<template>
  <a-modal
    :title="title"
    width="40%"
    :visible="visible"
    :confirm-loading="confirmLoading"
    :maskClosable="false"
    :keyboard="false"
    @cancel="handleCancel"
    @ok="submit"
    :ok-text="saveText"
    cancel-text="取消"
    :destroyOnClose="true"
  >
    <div>
      <a-form-model
        ref="ruleForm"
        :model="form"
        :rules="rules"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
      >
        <a-form-model-item label="年份" prop="acquireYear">
          <a-date-picker
            placeholder="请选择年份"
            v-model="form.acquireYear"
            :open="yearShowOne"
            :locale="locale"
            :format="'YYYY'"
            mode="year"
            @openChange="openChangeOne"
            @panelChange="panelChangeOne"
            style="width: 100%"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <a-form-model-item label="名称" prop="honorName">
          <a-input
            v-model="form.honorName"
            placeholder="请输入名称"
            :disabled="disabeld"
          />
        </a-form-model-item>
        <!-- <a-form-model-item label="类别" prop="acquireYear">
          <a-select v-model="form.levelType">
            <a-select-option :value="item.value" v-for="item in typeList">{{
              item.title
            }}</a-select-option>
          </a-select>
        </a-form-model-item> -->
        <a-form-model-item label="数量" prop="amount">
          <a-input-number
            v-model="form.amount"
            min="1"
            precision="0"
            @blur="blurValue"
            style="width: 100%"
            placeholder="请输入数量"
            :disabled="disabeld"
          />
        </a-form-model-item>
      </a-form-model>
    </div>
  </a-modal>
</template>
    
<script>
import { getAction, postAction, putAction } from "@/api/index";
import zh_CN from "ant-design-vue/lib/locale-provider/zh_CN";
import locale from "ant-design-vue/es/date-picker/locale/zh_CN";
import moment from "moment";
import "moment/locale/zh-cn";
import BaseEditor from "@/components/common/BaseEditor.vue";
moment.locale("zh-cn");
export default {
  data() {
    return {
      visible: false,
      confirmLoading: false,
      labelCol: { span: 4 },
      wrapperCol: { span: 16 },
      other: "",
      form: {
        applyId: "",
        acquireYear: "",
        honorName: "",
        amount: "",
      },
      rules: {
        acquireYear: [
          {
            required: true,
            message: "请选择年份",
            //          type: 'string',
            trigger: "blur",
          },
        ],
        honorName: [
          {
            required: true,
            message: "请输入名称",
            trigger: "blur",
          },
        ],
        amount: [
          {
            required: true,
            message: "请输入数量",
            trigger: "blur",
          },
        ],
      },
      yearShowOne: false,
      zh_CN,
      locale,
      applyType: 2,
      // 添加还是编辑
      type: "",
      // 弹框标题
      title: "",
      xwlist: [],
      jblist: [],
      kclist: [],
      ishow: false,
      ifirst: true,
      declareType: 2, // 1 工作室 2 品牌
      typeList: [],
      disabeld: false,
      taskId: null,
      detailId: null,
      saveText: "保存",
    };
  },
  components: { BaseEditor },
  mounted() {
    this.getTypeList();
  },
  methods: {
    getTypeList() {
      this.typeList = [];
    },
    blurValue() {
      if (this.form.amount == "1") {
        this.ifirst = true;
      } else {
        this.ifirst = false;
        this.form.content = "";
      }
    },
    handleChange() {
      console.log(this.form.achievementType);
      if (this.form.achievementType == "SZKC") {
        this.ishow = true;
      } else {
        this.ishow = false;
        this.form.courseType = "";
      }
    },
    openChangeOne(status) {
      if (status) {
        this.yearShowOne = true;
      }
    },
    panelChangeOne(value) {
      this.form.acquireYear = value;
      this.$refs.ruleForm.clearValidate("acquireYear");
      this.yearShowOne = false;
    },
    init(type, record, taskId, detailId) {
      this.type = type;
      this.visible = true;
      if (type == "add") {
        this.form = {};
        this.form.applyId = record.id;
        this.title = "新增荣誉";
      } else if (type == "edit") {
        this.title = "编辑荣誉";
        this.form = {
          id: record.id,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          honorName: record.honorName,
          amount: record.amount,

          // title: record.title,
          // achievementType: record.achievementType,
          // levelType: record.levelType,
          // courseType: record.courseType,
          // content: record.content,
        };
      } else if (type === "audit-edit") {
        this.title = "编编辑荣誉";
        this.saveText = "提交";
        this.taskId = taskId;
        this.detailId = detailId;
        // 合并所有字段，确保编辑时能正确显示原有数据
        this.form = {
          id: record.id,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          honorName: record.honorName,
          amount: record.amount,
        };
      } else {
        this.disabeld = true;
        this.title = "查看荣誉";
        this.saveText = "关闭";
        this.form = {
          id: record.id,
          applyId: record.applyId,
          acquireYear: record.acquireYear,
          honorName: record.honorName,
          amount: record.amount,

          // title: record.title,
          // achievementType: record.achievementType,
          // levelType: record.levelType,
          // courseType: record.courseType,
          // content: record.content,
        };
      }
    },
    handleCancel() {
      this.visible = false;
      //     this.yearShowOne = false;
    },
    submit() {
      if (this.disabeld) {
        this.visible = false;
        return;
      }
      //  	this.$refs.ruleForm.clearValidate();
      if (
        typeof this.form.acquireYear == "object" &&
        this.form.acquireYear != "" &&
        this.type == "add"
      ) {
        this.form.acquireYear =
          new Date(this.form.acquireYear).getFullYear() + "";
      }
      this.$refs.ruleForm.validate((valid) => {
        //    	console.log(valid);
        if (valid) {
          //					this.yearShowOne = false;
          if (this.type == "add") {
            let params = { ...this.form, declareType: this.declareType };
            //          params.acquireYear=new Date(this.form.acquireYear).getFullYear()+"";
            params.applyType = this.applyType;
            postAction("/lx/lxHonor/add", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("添加成功");
                this.$emit("addGain");
              } else {
                this.$message.error(res.message);
              }
            });
          } else if (this.type == "audit-edit") {
            let params = {
              taskId: this.taskId,
              afterJson: JSON.stringify({ ...this.form }),
              detailId: this.detailId,
            };
            postAction("/audit/lxAuditTask/reSubmitTask", params).then(
              (res) => {
                if (res.code == 200) {
                  this.visible = false;
                  this.$message.success(res.message || "编辑成功");
                  this.$emit("addGain");
                } else {
                  this.$message.error(res.message);
                }
              }
            );
          } else {
            let params = { ...this.form, declareType: this.declareType };
            if (typeof this.form.acquireYear == "object") {
              params.acquireYear =
                new Date(this.form.acquireYear).getFullYear() + "";
            }
            params.applyType = this.applyType;
            putAction("/lx/lxHonor/edit", params).then((res) => {
              if (res.code == 200) {
                this.visible = false;
                this.$message.success("编辑成功");
                this.$emit("addGain");
              } else {
                this.$message.error(res.message);
              }
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
  
<style lang="scss" scoped>
/deep/ .ant-modal-title {
  text-align: center;
}
/deep/ .ant-input-number-handler-wrap {
  display: none;
}
</style>
  